
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import StaticPageTemplate from '@/components/StaticTemplate';
import useTranslation from 'next-translate/useTranslation';
import type { GetStaticProps } from 'next';
import ForSection from '@/components/Services/ForSection';
import {
  HiOutlineArrowPath,
  HiOutlineCheckBadge,
  HiOutlineClipboardDocumentList,
  HiOutlineGlobeAlt,
  HiOutlinePencilSquare,
  HiOutlineWrenchScrewdriver,
} from 'react-icons/hi2';
import WorkSection from '@/components/Services/WorkSection';
import ExpertiseSection from '@/components/Services/Expertise';
import ContactSection from '@/components/Services/Contact';

function MyPage() {
  const { t } = useTranslation();
  const title = t('services:Logistics.title');
  const subtitle = t('services:Logistics.subtitle');

  const sellerBlocks = [
    {
      title: t('services:Logistics.blockSell1'),
      icon: <HiOutlineClipboardDocumentList className='text-2xl' />,
    },
    {
      title: t('services:Logistics.blockSell2'),
      icon: <HiOutlineWrenchScrewdriver className='text-2xl' />,
    },
    {
      title: t('services:Logistics.blockSell3'),
      icon: <HiOutlineCheckBadge className='text-2xl' />,
    },
  ];
  const buyerBlocks = [
    {
      title: t('services:Logistics.blockBuy1'),
      icon: <HiOutlineArrowPath className='text-2xl' />,
    },
    {
      title: t('services:Logistics.blockBuy2'),
      icon: <HiOutlinePencilSquare className='text-2xl' />,
    },
    {
      title: t('services:Logistics.blockBuy3'),
      icon: <HiOutlineGlobeAlt className='text-2xl' />,
    },
  ];

  const components = [
    <ForSection
      sellText={t('services:Logistics.sellForText')}
      buyText={t('services:Logistics.buyForText')}
      key={'for'}
      buyerBlocks={buyerBlocks}
      sellerBlocks={sellerBlocks}
    />,
    <WorkSection
      sellText={t('services:Logistics.sellingProcess')}
      buyText={t('services:Logistics.buyingProcess')}
      key={'work'}
    />,
    <ExpertiseSection
      text={t('services:Logistics.expertise')}
      key={'expertise'}
    />,
    <ContactSection key={'contact'} />,
  ];

  return (
    <StaticPageTemplate
      title={title}
      service={true}
      subtitle={subtitle}
      components={components}
    />
  );
}

 const _getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      hasContainer: false,
    },
  };
};

export default MyPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/services/international-logistics',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  